import moment from 'moment'
export default class CaregiverTableRowModel {
  constructor () {
    this.id = 0
    this.type = ''
    this.name = ''
    this.phone = ''
    this.address = ''
    this.rating = 0
    this.cases = 0
    this.shifts = ''
    this.level = ''
    this.lastActive = ''
  }

  static fromJSON (json) {
    let tableRow = new CaregiverTableRowModel()
    tableRow.id = json.id
    tableRow.type = json.type
    tableRow.name = json.name
    tableRow.phone = json.phone
    tableRow.address = json.address
    tableRow.rating = json.rating
    tableRow.cases = json.cases
    tableRow.shifts = json.shifts
    tableRow.level = json.level
    tableRow.lastActive = json.lastActive === '' ? '-' : moment(json.lastActive).format('DD/MM/YYYY, HH:mm')
    return tableRow
  }
}
